import { AppRoute } from "app";
import { atom } from "jotai";

export interface AppFlowRoute {
  path: AppRoute;
  checkpoint?: string;
}

export const appFlowAtom = atom<AppFlowRoute[]>([]);

export const flowWithProgressStepperAtom = atom<AppFlowRoute[]>([]);
